/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthSelectionRelationType } from './PalReauthSelectionRelationType';
import {
    PalReauthSelectionRelationTypeFromJSON,
    PalReauthSelectionRelationTypeFromJSONTyped,
    PalReauthSelectionRelationTypeToJSON,
    PalReauthSelectionRelationTypeToJSONTyped,
} from './PalReauthSelectionRelationType';

/**
 * 
 * @export
 * @interface PalReauthDocumentSelectionChange
 */
export interface PalReauthDocumentSelectionChange {
    /**
     * 
     */
    relation_type: PalReauthSelectionRelationType;
    /**
     * external_emr_documents.id, screener_generated_documents.id or screener_pal_reauth_additional_documents.id, depending on relation_type.
     */
    relation_id: string;
    /**
     * 
     */
    is_selected: boolean;
}



/**
 * Check if a given object implements the PalReauthDocumentSelectionChange interface.
 */
export function instanceOfPalReauthDocumentSelectionChange(value: object): value is PalReauthDocumentSelectionChange {
    if (!('relation_type' in value) || value['relation_type'] === undefined) return false;
    if (!('relation_id' in value) || value['relation_id'] === undefined) return false;
    if (!('is_selected' in value) || value['is_selected'] === undefined) return false;
    return true;
}

export function PalReauthDocumentSelectionChangeFromJSON(json: any): PalReauthDocumentSelectionChange {
    return PalReauthDocumentSelectionChangeFromJSONTyped(json, false);
}

export function PalReauthDocumentSelectionChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthDocumentSelectionChange {
    if (json == null) {
        return json;
    }
    return {
        
        'relation_type': PalReauthSelectionRelationTypeFromJSON(json['relation_type']),
        'relation_id': json['relation_id'],
        'is_selected': json['is_selected'],
    };
}

export function PalReauthDocumentSelectionChangeToJSON(json: any): PalReauthDocumentSelectionChange {
    return PalReauthDocumentSelectionChangeToJSONTyped(json, false);
}

export function PalReauthDocumentSelectionChangeToJSONTyped(value?: PalReauthDocumentSelectionChange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relation_type': PalReauthSelectionRelationTypeToJSON(value['relation_type']),
        'relation_id': value['relation_id'],
        'is_selected': value['is_selected'],
    };
}

